import React from 'react';
import If from 'src/components/Shared/If/If';
import { DELIVERY_MAIL_CHECK, DELIVERY_IN_KIND } from 'src/settings/settings';
import { mailCheckToNamePicker } from 'src/utils/funds/funds-utility';
import { isCollegeDistribute } from 'src/utils/transactions-util';
import SellAddressReview from '../SellAddressReview';
import SellBankReview from '../SellBankReview';
import SellDeductionsReviewRow from '../SellDeductionsReviewRow/SellDeductionsReviewRow';
import SellFundReviewRow from '../SellFundReviewRow/SellFundReviewRow';
import SellSelectedFundAmount from '../SellSelectedFundAmount/SellSelectedFundAmount';
import SellTradeDateReviewRow from '../SellTradeDateReviewRow/SellTradeDateReviewRow';
import SellTransactionEstimation from '../SellTransactionEstimation/SellTransactionEstimation';
import { currency } from 'src/utils/utils';

import './SellTransactionsReview.scss';

const SellTransactionsReview = ({
  address,
  deliveryMethod,
  displayTradeDate,
  hasMultipleNames,
  isEFT,
  isTakeHomeEstimated,
  multipleAddressFlag,
  selectedBank,
  selectedFunds,
  sellTakeHomeAmount,
  sellTotalAmount,
  sellTotalDeduction,
}) => (
  <div className="row sell-transactions-review">
    <div className="col-md-5 col-sm-6 col-xs-12 sell-transactions-review-mobile-border">
      <If test={isEFT}>
        <SellBankReview
          deliveryMethod={deliveryMethod}
          selectedBank={selectedBank}
        />
      </If>
      <If test={deliveryMethod === DELIVERY_MAIL_CHECK && !multipleAddressFlag}>
        <SellAddressReview
          address={address}
          name={mailCheckToNamePicker(selectedFunds[0]) || hasMultipleNames}
        />
      </If>
      <If test={deliveryMethod === DELIVERY_IN_KIND}>
        <div>In Kind Transfer</div>
      </If>
      <If test={deliveryMethod !== DELIVERY_IN_KIND}>
        <SellTransactionEstimation deliveryMethod={deliveryMethod} />
      </If>
    </div>
    <div className="sell-transactions-review-space col-md-7 col-sm-6 col-xs-12">
      {selectedFunds.map((fund, i) => {
        return (
          <div key={i} className="sell-transactions-review-funds-row">
            <SellFundReviewRow deliveryMethod={deliveryMethod} fund={fund} />
            <div>
              {deliveryMethod === DELIVERY_IN_KIND ? (
                <div>
                  <div className="in-kind-amount">
                    {currency(fund.balanceAsOf)}
                  </div>
                  <div className="in-kind-amount-percent">(100% funded)</div>
                </div>
              ) : (
                <SellSelectedFundAmount fund={fund} />
              )}
            </div>
          </div>
        );
      })}
      <If test={!isCollegeDistribute() && deliveryMethod !== DELIVERY_IN_KIND}>
        <SellDeductionsReviewRow
          address={address}
          selectedFunds={selectedFunds}
          sellTotalAmount={sellTotalAmount}
          sellTotalDeduction={sellTotalDeduction}
        />
      </If>
    </div>
    <If test={deliveryMethod !== DELIVERY_IN_KIND}>
      <SellTradeDateReviewRow
        deliveryMethod={deliveryMethod}
        displayTradeDate={displayTradeDate}
        isTakeHomeEstimated={isTakeHomeEstimated}
        sellTakeHomeAmount={sellTakeHomeAmount}
        sellTotalAmount={sellTotalAmount}
      />
    </If>
  </div>
);

export default SellTransactionsReview;
